import React from 'react';
import { classificationPathsOf } from '@/components/foresightClassification';

const ForesightClassificationTrail = ({ incident }) => {
  const paths = classificationPathsOf(incident);

  return (
    <div
      className="mt-2 grid gap-2"
      data-testid={`classification-foresight-hierarchy-${incident.id}`}
    >
      {paths.map((path, pathIndex) => (
        <div
          key={`${path.event}-${path.trigger}-${pathIndex}`}
          className="flex flex-wrap items-center gap-1.5"
        >
          {[
            ['Incident Type', path.incidentType],
            ['Event', path.event],
            ['Trigger', path.trigger],
          ].map(([label, value], index) => (
            <React.Fragment key={`${label}-${index}`}>
              {index > 0 && <span className="text-[11px] font-black text-slate-300">→</span>}
              <span className={`inline-grid gap-0.5 rounded-lg border px-2 py-1 ${
                value
                  ? 'border-sky-200 bg-sky-50 text-slate-700'
                  : 'border-dashed border-slate-200 bg-slate-50 text-slate-400'
              }`}>
                <small className="text-[8px] font-black uppercase tracking-[0.08em] text-slate-400">
                  {label}
                </small>
                <b className="max-w-[180px] truncate text-[10.5px]" title={value || 'Not specified'}>
                  {value || 'Not specified'}
                </b>
              </span>
            </React.Fragment>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ForesightClassificationTrail;
